import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/modal-exit/preguntas-exit-intent.svg")